<h1 style="text-align: center;">FCiR24 - Financial Cryptography in Rome 2024</h1>
<p>
    Joint workshop: Banca d'Italia and De Componendis Cifris.
</p>
<h2>Organizers</h2>
<p>
    <b></b>
    <em>
        Michela Iezzi (Banca d'Italia, Italy)
        <br>
        Massimiliano Sala (De Componendis Cifris, Italy)
    </em>
</p>
<h2>Description</h2>
<p>
    <b>Financial Cryptography in Rome</b> (FCiR) and Data Security covers all aspects of securing transactions and
    digital
    value, with a specific focus on commercial and currency contexts. While we hosts cryptographic talks on both
    fundamental research and real-world applications, we encourage also interdisciplinary works not strictly related to
    cryptography.
</p>
<h2>Program</h2>
<p>
    <i> September 27th, workshop session</i>
    <br>
    <i> Main hall, 10:00 - 13:00</i>
</p>
<p>
    Invited speakers:
    <br>
    <b>Carsten Maple</b>, University of Warwick (UK)
    <br>
    <b>Christian Rechberger</b>, Graz University of Technology (Austria)
</p>
<table class="orari" cellspacing="2" cellpadding="2" id="27afternoon">
    <tr bgcolor="lightblue" id="raipqc24">
        <th class="schedule" colspan="2">
            <font size="+1"><b>Session I - September 27th (morning) - Workshop Session</b></font>
        </th>
    </tr>
    <tr>
        <td colspan="2">
            <h2>INVITED TALKS</h2>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            10:00
            <br>
            10:40
        </td>
        <td>
            <i>
                <b>Carsten Maple</b>, University of Warwick (UK)
            </i>
            <br>
            Keynote: Secure and Private Data Sharing in Financial Institutions
            <details>
                <summary>
                    Abstract
                </summary>
                Financial institutions are increasingly relying on data to inform strategy and operations but are
                hampered from sharing this information within and beyond their organisation for a range of reasons. This
                talk will present some of the use cases for information sharing and present recent work in Privacy
                Enhancing Technologies, including Homomorphic Encryption, that has facilitated such information
                exchange.
            </details>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            10:40
            <br>
            11:20
        </td>
        <td>
            <i>
                <b>Christian Rechberger</b>, Graz University of Technology (Austria)
            </i>
            <br>
            Keynote: Progress on Private Computation
            (<a target="_blank" href="https://drive.google.com/file/d/1WX-RERrhly8qvEjodsMgXuMXA3fZBCcG">slides</a>)
            <details>
                <summary>
                    Abstract
                </summary>
                Encrypting all kinds of traffic on the internet is ubiquitous since about a decade, that 'lock icon' in
                some corner in our browser windows is a symbol of that. The invention and development of public key
                cryptography in the decades before was a major driver behind this development. The elephant in the room:
                In order to compute on the transmitted data, it needs to be decrypted, hence forgoing many of the
                protections at that point. New inventions and developments in cryptography are about to close this gap:
                Homomorphic encryption, secure multiparty computation, or zero-knowledge proofs. Huge efficiency
                improvements have already been achieved, and more improvements are in the pipeline. Open-source
                solutions are maturing. Commercialization, albeit in its infancy, is in progress. We review some of
                these developments and sketch the road ahead.
            </details>
        </td>
    </tr>
</table>






<table class="orari" cellspacing="2" cellpadding="2" id="27afternoon">
    <tr bgcolor="lightblue" id="raipqc24">
        <th class="schedule" colspan="2">
            <font size="+1"><b>Session II - September 27th (morning) - Workshop Session</b></font>
        </th>
    </tr>
    <tr>
        <td colspan="2">
            <h2>CONTRIBUTED TALKS</h2>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            11:40
            <br>
            12:00
        </td>
        <td>
            <i>
                <b>Giuseppe Galano</b>, Bank of Italy (Italy)
            </i>
            <br>
            Layer-2 Innovations for Scalable Blockchain Payments
            (<a target="_blank" href="https://drive.google.com/file/d/1hwfsuW4RbD6zVKHPrt4dI-cK8o5SONxQ">slides</a>)
            <details>
                <summary>
                    Abstract
                </summary>
                The work explores Layer-2 innovations designed to enhance the scalability of payments within Bitcoin's
                distributed ledger technology. By leveraging potential future advancements in blockchain capabilities,
                more sophisticated second-layer solutions can be envisioned, addressing the challenges of traditional
                off-chain protocols while maintaining security. The discussion centers on the most promising proposals
                and their trade-offs.
            </details>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            12:00
            <br>
            12:20
        </td>
        <td>
            <i>
                <b>Amit Chaudhary</b>, Labyrinth Technology (UK)
            </i>
            <br>
            Decentralized Finance: Labyrinth
            (<a target="_blank" href="https://drive.google.com/file/d/1pJbV-bCrvFLJrq3Mbwa_7JT3ZRWESH64">slides</a>)
            <details>
                <summary>
                    Abstract
                </summary>
                We propose a middleware solution designed to facilitate seamless integration of privacy using
                zero-knowledge proofs within various multi-chain protocols, encompassing domains such as DeFi, gaming,
                social networks, DAOs, e-commerce, and the metaverse. Our design achieves two divergent goals: to
                preserve consumer privacy while achieving finance regulation compliance.
            </details>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            12:20
            <br>
            12:40
        </td>
        <td>
            <i>
                <b>Luigi Bellomarini</b>, <b>Costanza Catalano</b>, <b>Andrea Coletta</b>, <b>Michela Iezzi</b>, Bank of
                Italy (Italy)
            </i>
            <br>
            Confidential Knowledge Graphs through Synthetic Augmentation
            <details>
                <summary>
                    Abstract
                </summary>
                Sharing Knowledge Graphs (KGs) between organisations is essential to set up effective business processes
                in the financial domain, yet this should be done without disclosing privacy-sensitive data. In this
                work, we show that existing literature offers techniques to anonymize graphs, but does not support the
                presence of derived knowledge, like in the case of KGs. We investigate poten
                tial approaches for developing privacy-preserving techniques using synthetically
                augmented KGs.
            </details>
        </td>
    </tr>
    <tr>
        <td colspan="2">
            <h2>ROUND TABLE</h2>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            12:40
            <br>
            13:00
        </td>
        <td>
            <i>
                Final discussion and round table
            </i>
        </td>
    </tr>
</table>